<template>
    <div class="">
        <div class="modal fade" id="loginMoblizer" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body login-mobilizer text-left p-4">
                        <div class="login-mobilizer-inner p-5">
                            <img class="logo mb-3 text-center" src="/banks/MEEZAN.png" alt="Meezan Logo"/>
                            <div class="moblizer-account-login">
                                <span class="title mb-2"> Enter your corporate <span class="highlight-color">Meezan</span> Account PIN </span>
                                <div class="form-group mb-2">
                                    <input v-model="form.Key" type="text" class="form-control" readonly placeholder="Enter NTN" @keypress="isNumber($event)" maxlength="13" name="Key" :class="{ 'is-invalid': form.errors.has('Key') }" />
                                    <has-error :form="form" field="Key"></has-error>
                                </div>
                                <div class="form-group mb-2">
                                    <input v-model="form.OldPin" type="password" name="OldPin" class="form-control" @keypress="isNumber($event)" maxlength="4" placeholder="Enter 4 digit Pin" :class="{ 'is-invalid': form.errors.has('OldPin') }" autocomplete="off"/>
                                    <has-error :form="form" field="OldPin"></has-error>
                                </div>
                                <span class="title mb-2"> Do you really want to proceed? </span>
                                <div class="row normal-ib-space">
                                    <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                    <div class="col"> <button class="btn btn-primary proceed active" @click="proceedLogin" :disabled="busy"> Proceed </button> </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    export default {
        props:['billIds','paymentType','payrollTotalAmount','payroll_id','topup_id', 'meezan_balance', 'payableTxnAmount'],

        data() {
            return {
                busy: false,
                form: new Form({
                    Key : '',
                    OldPin : '',
                }),
                processForm : new Form({ // null emelment are extra
                    billIds  : this.billIds,
                    payroll_id  : this.payroll_id,
                    // topup_id : this.topup_id,
                    payrollTotalAmount : this.payrollTotalAmount,
                    payableTxnAmount : this.payableTxnAmount,
                    meezan_balance : this.meezan_balance,
                    paymentReprocess : false
                }),
            };
        },
        mounted() {
            this.getCompanyNTN();
            // EventBus.$on('paymentReprocess', data => {
            //    this.processForm.paymentReprocess = data;
            // });
        },
        methods:{
            getCompanyNTN(){
                this.$Progress.start();
                axios.get('/api/getCompanyNTN')
                .then(res => {
                    if(res.status == 200){
                        this.form.Key = res.data.company.ntn;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            },

            proceedLogin: function(){
                this.busy = true;
                if(this.form.Key == '' || this.form.OldPin == ''){
                    this.busy = false;
                    this.showToastBox('error','Please enter the credentials!');
                    return;
                }
                this.$Progress.start();
                this.form.post('/api/verifyMpin')
                    .then(res => {
                        if(res.data.status == 200){
                            this.busy = false;
                            this.$Progress.finish();
                            $('#loginMoblizer').modal('hide');
                            switch (this.paymentType) {
                                case 'bill_payment':
                                    this.processBills();return;
                                case 'employee_payment':
                                    this.corpLoginForPayments();return;
                                // case 'topup_payment':
                                //     this.corpLoginForTopup();return;
                                case 'vendor_payment':
                                    this.corpLoginForVendor();return;
                                case 'pms_membership_payment':
                                    this.corpLoginForPms();return;
                            }
                        }else{
                            this.busy = false;
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.busy = false;
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });

            },
            processBills: function(){
              this.$Progress.start();
              this.processForm.post('/api/billSendForPayment')
                  .then(res => {
                    if(res.status == 200){
                      // $('#dt-new').DataTable().ajax.reload();
                      this.$Progress.finish();
                      $('#loginMoblizer').modal('hide');
                      this.$router.push('/billPayments');
                      this.showToastBox('success','Bill proceed successfully');
                    }else{
                      this.$Progress.fail();
                      this.showAlertBox('error','Fail to fetch data')
                    }

                  })
                  .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                  });
            },
            corpLoginForPayments: function(){
                this.$Progress.start();
                if(parseInt(this.meezan_balance) >= parseInt(this.payableTxnAmount)){
                    this.processForm.post('/api/proceedBatchQueue')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                                this.$router.push('/employeePayments');                                   
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
                }else{
                    this.showAlertBox('error','Insufficient Balance in your account');
                }
            },
            corpLoginForVendor: function(){
                this.$Progress.start();
                if(parseInt(this.meezan_balance) >= parseInt(this.payableTxnAmount)){
                    this.processForm.post('/api/VendorSendForPayment')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                                this.$router.push('/vendorPayment');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }

                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
                }else{
                    this.showAlertBox('error','Insufficient Balance in your account');
                }
            },
            corpLoginForPms: function(){

                this.showToastBox('success', 'Success');

                this.$emit('corpLoginSuccess', {
                    bank: 'meezan',
                    data: null
                });
            },

            cancelMobilizer: function(){
                $('#loginMoblizer').find('.moblizer-account-login').removeClass('hide');
                $('#loginMoblizer').find('.moblizer-account-detail').addClass('hide');
            },
        },
        destroyed: function() {
            // EventBus.$off('paymentReprocess');
        }

    }
</script>
